module.exports = __webpack_public_path__ + "img/宣传_182.4ed07160.jpg";